import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EntitySelect.html?raw';

import SelectBox from '../../SelectBox/SelectBox';
import '../../SelectBox/SelectBox';
import _LabelInputBase from '../../_LabelInputBase/_LabelInputBase';
import _InputMultiBase from '../../_InputMultiBase/_InputMultiBase';
//import DataItems = require("DataItems");


class EntitySelect extends compose(_InputMultiBase) {
    templateString: any = template;

    selectBox: MdsLax<InstanceType<typeof SelectBox>>;
    labelAttribute: string = null;
    valueAttribute: string = "ID";
    selectableAttribute: string = null;
    headingAttribute: string = null;

    blankOption: any = null; // Element!
    blankOptionText: string = null;
    blankOptionValue: string = "-x-";
    blankOptionAvailable: boolean = false;

    requestUrl_additionalSearchParameter: Array<object> = [];
    requestUrlParameterValue: string | Array<string>;

    private entities: Array<any> = [];
    private _selectedEntity: any;
    url: string = null;
    private _request: any = null;

    setValue(newValue: string | object, bSuppressChange?: boolean, forceIfDisabled?: boolean, delimiter?: string): void {

        let stringValue = null;
        if (typeof (newValue) == "string") {
            stringValue = <string>newValue;
        } else {
            stringValue = this.PitHelper.getEntityAttributeValue(newValue, this.valueAttribute, this.dataFormat);
        }

        this._selectedEntity = this.getEntityByValue(stringValue);

        this.selectBox.setValue(stringValue, bSuppressChange == true, forceIfDisabled == true, delimiter);
    }

    setMultipleValues(newValues: Array<string>, unselectOther?: boolean, bSuppressChange?: boolean, forceIfDisabled?: boolean): void {
        this.selectBox.setMultipleValues(newValues, unselectOther == true, bSuppressChange == true, forceIfDisabled == true);
        this.isMultiSelect = this.selectBox.isMultiSelect;
    }

    getMultipleValues(bReturnLabels?: boolean): Array<string> {
        return this.selectBox.getMultipleValues(bReturnLabels);
    }

    getValue(bReturnStringValue?: boolean): string | object {

        if (bReturnStringValue == true) {
            return this._value;
        }
        return this._selectedEntity;
    }

    setMandatory(bMandatory: boolean = true): void {
        this.selectBox.setMandatory(bMandatory);
        this.isMandatory = this.selectBox.isMandatory;
    }

    setMultiselect(bMultipleAllowed: boolean, height?: number): void {
        this.selectBox.setMultiselect(bMultipleAllowed, height);
        this.isMultiSelect = this.selectBox.isMultiSelect;
    }

    setMultiselectHeight(lines: number): void {
        this.selectBox.setMultiselectHeight(lines);
    }

    setSelectHeight(lines: number): void {
        this.setMultiselectHeight(lines);
    }

    private _setMultiselectSizeAttr(value: number): void {
        this.setMultiselectHeight(value);
    }

    protected customValidation(): boolean {

        let result = this.selectBox.validateInput();

        return result;
    }

    setValidationEnabled(bEnable?: boolean) {
        super.setValidationEnabled.apply(this, arguments as any);

        this.selectBox.setValidationEnabled(this.validationEnabled);
    }

    setAdditionalRequestParams(param: string, value: string): void {
        let obj: object = {};

        for (let i = 0; i < this.requestUrl_additionalSearchParameter.length; i++) {
            let entry = this.requestUrl_additionalSearchParameter[i];

            if (entry.hasOwnProperty(param)) {
                entry[param] = value;
                return;
            }
        }
        obj[param] = value;
        this.requestUrl_additionalSearchParameter.push(obj);
    }

    getAdditionalRequestParams(): string {
        return JSON.stringify(this.requestUrl_additionalSearchParameter);
    }

    removeAdditionalRequestParam(paramKey: string, paramValue?: string): void {

        let values: Array<object> = this.requestUrl_additionalSearchParameter;

        let obj = values.filter(object => object[paramKey] === paramValue);
        values.splice(values.indexOf(obj), 1);

    }

    emptyAdditionalRequestParams(): void {

        this.requestUrl_additionalSearchParameter = [];

    }

    private _loadListValues(presetValue?: any, bSuppressChange?:boolean): void {

        // nicht resetten, evtl wird ein Wert gesetzt und die möglichen Werte danach nachgeladen
        //

        //console.log("_loadListValues", this.id, );
        if (typeof (presetValue) != "undefined") {
            this.setValue(presetValue, bSuppressChange === true);
            if (bSuppressChange) this.validateInput();
        }
        else {
            this._selectedEntity = null;
            this.selectBox.setValue(null, true, true);
        }


        var url;
        if (this.url == null) {
            return;
        } else {
            url = this.url;
        }

        this.StandbyStart();

        let requestParams = this.getAdditionalRequestParams();

        var requestUrl = window.appRoot + url;

        //console.log("selectbox _loadListValues", requestUrl, requestParams, presetValue);

        this._request = this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, "_onLoadListValuesResponse", presetValue, bSuppressChange),
            lang.hitch(this, "_onLoadListValuesError"),
            false // sync
        );
    }

    private _onLoadListValuesResponse(presetValue: any, bSuppressChange: boolean, response: Array<object> | string): void { // responsecallback
        console.log(this.id + " _onLoadListValuesResponse - response - preset - suppress", response, presetValue, bSuppressChange);
        this._request = null;

        if (typeof (response) == "string") { // Kompatibilität mit bisher doppelt stringifizierten JSON-Responses
            this.entities = JSON.parse(response);
        } else {
            this.entities = response;
        }

        this._constructOptions();

        if (presetValue != null && typeof (presetValue) != "undefined") {
            this.setValue(presetValue, bSuppressChange);
        }

        this.StandbyStop();
    }

    private _onLoadListValuesError(err:any): void { // errorCallback
        console.error("_onLoadListValuesError", err);
        this._request = null;

        if (typeof (err) == "object") {
            alert(err.Message);
        } else {
            alert(err);
        }
        this.StandbyStop();
    }

    private _constructOptions(): void {

        // select leeren / resetten!
        this.selectBox.clear(true);

        for (var i = 0; i < this.entities.length; i++) {
            let entity = this.entities[i];

            let isSelectable: boolean = true;
            if (this.selectableAttribute != null) {
                //console.debug("entitySelect selectablecheck", this.PitHelper.getEntityAttributeValue(entity, this.selectableAttribute, "json"));
                isSelectable = this.PitHelper.getEntityAttributeValue(entity, this.selectableAttribute, this.dataFormat) == true;
            }

            this.selectBox.addEntry(this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute, this.dataFormat), this.PitHelper.getEntityAttributeValue(entity, this.labelAttribute, this.dataFormat), isSelectable == true);
        }

        this.selectBox.constructOptions();
    }

    /**
* Leer-Wert abrufen (für Vergleich ob bereits ein "valider" Wert ausgewählt wurde)
*/
    getBlankValue(): string {
        return this.selectBox.blankOption.value;
    }

    // Label
    /**
    * Label zum Input umtaufen. Das Label wird dabei gleichzeitig eingeblendet.
    */


    protected setLabelValue(): void {
        this.selectBox.setLabel(this._label);
    }

    protected setIsLabelVisibleStyle(): void {
        this.selectBox.setLabelVisibility(this._isLabelVisible);
    }


    /**
    * neuen Eintrag zu den auswählbaren Optionen hinzufügen
     * ACHTUNG: wird noch nicht im Control erzeugt!
    */
    addEntry(entity: any): any {

        let value: string = this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute);
        let label: string = this.PitHelper.getEntityAttributeValue(entity, this.labelAttribute);
        let isSelectable: boolean = this.selectableAttribute == null || this.PitHelper.getEntityAttributeValue(entity, this.selectableAttribute, this.dataFormat) == true;

        let entry = this.selectBox.addEntry(value, label, isSelectable);

        this.entities.push(entity);

        return entry;

    }

    /**
    * neuen Eintrag zu den auswählbaren Optionen hinzufügen (Alias für addEntry)
     * ACHTUNG: wird noch nicht im Control erzeugt!
    */
    addOption(entity: any): any {
        return this.addEntry(entity);
    }

    /**
    * (leere) Standardauswahl erzeugen, üblicherweise als Platzhalter
     * Achtung: muss mit constructOptions bestätigt werden!
    */
    setBlankOption(value: string, label: string, isSelectable?: boolean) {
        this.blankOptionAvailable = isSelectable;
        this.blankOptionValue = value;
        this.blankOptionText = label;
        this._value = value;
        this.selectBox.setBlankOption(value, label, isSelectable);
    }

    /**
    * Options-Einträge aus den Entries erzeugen. Diese müssen vorher befüllt sein!
    */
    constructOptions(): void {
        this.selectBox.constructOptions();
    }


    setPlaceholder(text: string): void {
        this.setBlankOption('$$xyz##$$', text, false);
    }

    // dojo

    _setBlankOptionAttr(value: string, label: string, bAvailable: boolean) {
        this.setBlankOption(value, label, bAvailable);
       
    }
    _setBlankOptionTextAttr(label: string) {
        if (!label) {
            this.setBlankOption(null, null, false);
        } else {
            this.setBlankOption(this.blankOptionValue, label, this.blankOptionAvailable);
        }
    }

    private _setSelectableAttributeAttr(value: string): void {
        if (value == "") {
            this.selectableAttribute = null;
            return;
        }
        this.selectableAttribute = value;
    }

    _setLabelAttr(value: string): void {
        this.selectBox._setLabelAttr(value);
    }

    private _onValueChange(value: string): void {
        //console.log("entitySelect - selectbox valuechange " + this.id, value);
        this._selectedEntity = this.getEntityByValue(value);
        this._value = value;
        this.validateInput();

        this.__delayValueChangeEmit(10);
    }

    _setReadonlyStyle() {
       this.selectBox.setReadonly(this.isReadonly);
    }

    protected getEntityByValue(value: string): object {
        for (var i = 0; i < this.entities.length; i++) {
            let entity = this.entities[i];

            if (this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute, this.dataFormat ) == value) {
                return entity;
            }
        }

        return null;
    }

    postCreate(args?: any): void {
        super.postCreate.apply(this, arguments as any);

        this.entities = [];
        this.requestUrl_additionalSearchParameter = [];
    }

    startup(args?: any): void {
        super.startup.apply(this, arguments as any);

        this._loadListValues();

        //if (this.selectBox == null) {
        //    this.selectBox = new SelectBox();
        //}


        //this.selectBox.addEntry("a", "erste Option A", true);
        //this.selectBox.addEntry("b", "zweite Option B", true);
        //this.selectBox.addEntry("c", "nicht auswählbar", false);
        //this.selectBox.constructOptions();
    }
}

export default mdsWidget(EntitySelect);